import api from '~/store/idonia-api/api'
import $state from '~/plugins/uploader/download-state.js'
import FILE_STATES from '~/plugins/uploader/file-states'
import store from '~/store/store'

export default {
  name: 'file.zipped',
  background (payload, {dispatch, state}, {sha, token, socket}) {
    const {fileID, taskUUID, task_id, url} = payload
    if (task_id !== undefined || taskUUID !== undefined) {
      if (task_id !== '') {
        $state.updateFileState(task_id, FILE_STATES.completed)
      }
      if (url) {
        api.downloadUrl(url)
      } else {
        if (sha) {
          const guestAuth = store.getters['session/guestAuthentication'][sha]
          api.downloadBlob('file/' + fileID + '/download/' + taskUUID, {
            headers: {
              Authorization: guestAuth
            }
          })
        } else {
          api.download('file/' + fileID + '/download/' + taskUUID)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/FileZipped.js